
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as menu_5LQ2iRUrcWsI9qKa4VmHgpYL_QB2FYwYYjVATpVUnYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/menu.vue?macro=true";
import { default as index5mcJsyamMu3HIAvRv2zW0JqWSAW7FMS8ByJhP9HmDVUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/index.vue?macro=true";
import { default as loginoR_45_ZwLqtQu9dezuSOVdd4Cnocq0zbBAFm75lBcKBmMMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/login.vue?macro=true";
import { default as _91page_932cGcj3_1PEQB_LRWsxk5b_kP1aDDwQhq1dDLdm49XpIMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/[category]/[page].vue?macro=true";
import { default as _91page_93lOJLmGNGawOa08hqsaYTK47uY9guRK8kYAsFAILSQa0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/svi-oglasi/[page].vue?macro=true";
import { default as _91page_93rfs3M1Nawu5F55qW69QRbX9gg4X8k1zg05mSdjsijk4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/mesto/[place]/[page].vue?macro=true";
import { default as _91page_93xk6RVsHXuIQod0VM_458YISdlXN2POrbaFQcFLb_k8_45YMMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/[category]/[subcategory]/[page].vue?macro=true";
import { default as _91page_93mRnSo8K44vPetXeWXxc3q1u_45Ir_J89MMBxBJA0USxPgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/mesto/[place]/[category]/[page].vue?macro=true";
import { default as _91page_93icaOkjdNoy4ryH7wZMlDWEo3PvfvKyFYA9P7qpI0mOwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/mesto/[place]/[category]/[subcategory]/[page].vue?macro=true";
import { default as oglasiR34Q3voNGoVQpmDbURSBzEWaXLAbmc6WL3MG8yQlQK0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi.vue?macro=true";
import { default as kontaktqzpr1mHakh0HQuEc8lxDtmXdOQkGcDFhe4cHTFgqY7QMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kontakt.vue?macro=true";
import { default as _91page_93MaUt4H3umhf41mMUEbsiMzwqEdTso5f_45o1MqdN4BGdcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/kategorije/[page].vue?macro=true";
import { default as _91page_93_bRC1feo23DGDD9kdt6i9zMBfLpHL1kNT23TJURazFwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/mesto/[place]/[page].vue?macro=true";
import { default as _91page_93L3BRqKAFpe2c7nVc5HHDEGe3bJaJ8pjQTAWEE3u6VK0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/kategorija/[category]/[page].vue?macro=true";
import { default as _91page_93APKC38qGNVcdcgU5r4ZFSYkjeeVoTr8SpPPmmrf0HHQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/kategorija/[category]/[place]/[page].vue?macro=true";
import { default as adresari0MuYQnPvV_45pLZoslZJI1wXmA9pRU7vFVsDeLUtjJOzsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/adresari.vue?macro=true";
import { default as cenovniki1RhN4wWRirq4QPC4_45Q0qH2IKRpxG_45TKJN_aFWxSVBoMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cenovnik.vue?macro=true";
import { default as pretragajtno_tfIrADovs9RR_45xzyjDxCoVDcBUmGG1_uY47oLwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/pretraga.vue?macro=true";
import { default as marketingsGBJ70pT61UGjWe0P71XhHBUgNbP0o8_45nHwsjkEOlnQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/marketing.vue?macro=true";
import { default as _91page_93TT9LMPm81BpITCHMKWdbncNuz_45RdzD1FPN1cAfNWVfAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/proizvodi/[category]/[subcategory]/[sort]/[page].vue?macro=true";
import { default as _91page_93OnPnaz4nNMyG_dGJIn0P0m37ODM5gOy6ze2uVSXOqIIMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/proizvodi/[category]/[subcategory]/[sort]/[filter]/[page].vue?macro=true";
import { default as proizvodiuC8A_DeTBxcAPuJLz_45h9og95s_451qojtHl9oVo1TdvEQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/proizvodi.vue?macro=true";
import { default as login_45videoGO56OuEaPyJKfsyNHj0GbFgy6aAIOHi2wa2P2xgI6I8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/login-video.vue?macro=true";
import { default as indexmqR4GNYkB6tJlyG7yk18_45zDfcNJMAIW9FbnCLZc1TnkMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/vesti/index.vue?macro=true";
import { default as indexpWDP2KVITIUJEeca5YluIcEK_t5QJ_45f5_cJCxYwO2okMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/video/index.vue?macro=true";
import { default as indexbLQ5YrkFMLNcgde8tyqoymHoeD2MTIbW3gD4ItRcs_UMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/anketa/index.vue?macro=true";
import { default as registracijaMCNdHItyUTxCnG3K25z_s49FP_4t5vvHovQ_45fV2EQ0MMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/registracija.vue?macro=true";
import { default as index9hbIXOISExsf4iQ5W1mXmG29zPRqKfe5qX1P4ksTBeEMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/saveti/index.vue?macro=true";
import { default as indexqoXs4tF7Jw5rFxaztQXI380BT_45yB5m7fpPEciaefpogMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/bolesti/index.vue?macro=true";
import { default as indexJmlqmgQk9t9k8gU0sftzPiXy_Rf0ds4nOg_TQLujEpMMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/zastita/index.vue?macro=true";
import { default as _91page_93biVggKBin8VaIrqUBLfx_45qf9fmhmwEjv8Bspu_ouc0YMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/recepti/[page].vue?macro=true";
import { default as oglasi_45pretragaqv2tCQ3debs5X1lZN6mHHuAwKSaMOns85y2GbnaRRZkMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi-pretraga.vue?macro=true";
import { default as indexumuQb4xLFwY4FHfTTDY_P1AZkZinGYnzSK7DprwG85gMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/preporuke/index.vue?macro=true";
import { default as recepti_45pretragaM5Iqylze8GwrVOzj0MwHlr0lsVIsF0kpZbXanI40uhoMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/recepti-pretraga.vue?macro=true";
import { default as indexHaRpfWuORMF2esdFC2TtgybeHPo46SLh7av8x3nXPFAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/index.vue?macro=true";
import { default as pratim_64bxZZ9KavRGMntAiRxltMscEmpmB0eCBQKd_rcF60Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pratim.vue?macro=true";
import { default as profilCVllKw6cdB_45Eg2auiv3fAc1e6f6sqTR2jEm0HeO9k_45AMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/profil.vue?macro=true";
import { default as pracenjeSG48YMg5NulbMrs3b8v_MJGUi2qqTx2pwOCZ8P9rMC4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pracenje.vue?macro=true";
import { default as pratiociTnG5hrerRBodysPOATxevPhJDUMPCx_AaPIVJ7cRKtcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pratioci.vue?macro=true";
import { default as indexwWoqoLKGDNUAFJh3zFC_45rm_454_pF5tntduaSKuoZM_zIMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/meni/index.vue?macro=true";
import { default as novi_45oglasZ5BQLWviQZzDVPInTBwY0jCQkwu_457YNcZkgvv8f_WkMMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/novi-oglas.vue?macro=true";
import { default as indexaDk4nSJ_45x5hdtPmHT1rbVF0fPkayBz3201vcr0MDMg8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/ocene/index.vue?macro=true";
import { default as aktivni_45oglasiIWaudVrcFugCUd4dCaSI1hMI_45GGuUopauGQQDJHvPoQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/aktivni-oglasi.vue?macro=true";
import { default as neaktivni_45oglasig5qNWdl_AG027U7kCbFr4uLbQvvBCuTOl3zXbPE_aqYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/neaktivni-oglasi.vue?macro=true";
import { default as indexu_45jy6v_BV5NdDGJ7yF89OwhriW0GSQGI2Z_4yDrOznkMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/obavestenja/index.vue?macro=true";
import { default as tezga_45registracija9R8hDKexx1j7qgB7mmlhHqnJ6GHO7AaRhMXBVu_uB64Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/tezga-registracija.vue?macro=true";
import { default as pristupni_45parametri1xghXc9sYkiCbU5ua11IropUOPNwWqmt_452_45EDdSIeYgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pristupni-parametri.vue?macro=true";
import { default as uspesno_45dodat_45oglasZwV49vZ1fmioMFANSNWeobrU6sFKTRqAyoDmh8uQAycMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/uspesno-dodat-oglas.vue?macro=true";
import { default as indexmoXrNJo3x0GSFEa2ugER_mWIqaxRiXbcogtoE40ZybYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/statistika/mesec/index.vue?macro=true";
import { default as indexGRzJy8_vOhy3u4PFduuvFQ6lRopHyoX_jwASkxXKxQsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/oglas/[title]/[id]/index.vue?macro=true";
import { default as indexuaMv_uPmkiClSZSkwT_45Ukc9wG4_XpVg6FEgTqwf2Cv8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/statistika/nedelja/index.vue?macro=true";
import { default as indexlOeyb_45u6Z2bnusP3FN30LjjPhXdwsTvBdil_aZt0D4gMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/poruke/prikaz-oglasa/index.vue?macro=true";
import { default as _91adid_93JNRhmz5TTNQ7BZcUapTBG9vbaxQxxjVAVTbhPxC38xoMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/poruke/slanje-poruke/[adid].vue?macro=true";
import { default as indexpe_owpDSVKWxSMhCECYXZPU2YsyAHezVG6joDVi8lJkMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/promena-podataka/[id]/index.vue?macro=true";
import { default as _91conversationid_93MI5TjvSSA6aCQNC9RoFCCU26B2PACemaiBnulo0QdUUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/poruke/slanje-poruke-oglas/[conversationid].vue?macro=true";
import { default as _91page_93Vj2A7z3psx_AKQxBPvoS8XHBxHeaC5Uy6mHOoOMEhEsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/ocene/[customerid]/[customertype]/[customerrate]/[page].vue?macro=true";
import { default as korisnicki_45profilfZYr0u4ueBfzuNc_45ezDzFkzvJkpvfp1MLsoCN958aZYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil.vue?macro=true";
import { default as uslovi_45koriscenjaIH9tniKdRHkKQ_vS2XT4DWizptBV0fIEb_45vyoUX9UxUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/uslovi-koriscenja.vue?macro=true";
import { default as indexBtJrcHgPtSCAE8djbuojLlAYrZXYXFK4_45BAQ_q9PYRYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena/[weeks]/index.vue?macro=true";
import { default as indext6fcwQWn07UWdeIpl7SZqTN7UNwz_45wHMgozbvmJcZyUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/index.vue?macro=true";
import { default as index_45Uww0EwpLVjldCpQ6zA3QDamJlas5rLtX_45vojVL8T1AMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/index.vue?macro=true";
import { default as _91page_93GYdHtGu0iRvpBl_w2Uv4XyI_45laOR8AjlzfEx25d_45GkwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/dogadjaji/[page].vue?macro=true";
import { default as indexqXy0XbpmL6ey7BFeintcAU1134LV5wee0pYUDfwMErgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/[title]/index.vue?macro=true";
import { default as _91page_93fENQikIbgm9amggIICJ6OmyarhRGPGunj50AEJXtOE4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/dogadjaji/[year]/[page].vue?macro=true";
import { default as _91page_936DUNxjRaIEE_ea_FOcLQBVZ8FkB4TmlMky6pbXtceQ4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/dogadjaji/[year]/[month]/[page].vue?macro=true";
import { default as _91page_93FD7kh0i7qfHI5BkfUZ1TstDPjT_45VlHz6TJAAjKVnOO0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/kategorija/[year]/[page].vue?macro=true";
import { default as _91page_932ec5AXgCInH7qgIOpfTkpiAUa11muuTG3TaksVn7hXUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/kategorija/[year]/[month]/[page].vue?macro=true";
import { default as kalendar_45dogadjajard1QCwngCjNWuHMyLJYvKqjxJHRLKkg1WAvjOU2JstQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja.vue?macro=true";
import { default as _91id_93elaEp2xXZXWuqGznEofbtdvsgx_45qo_kHzoS_45yfkAZwcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglas/[title]/[id].vue?macro=true";
import { default as indexYqw5bmK7A7LjcU_45ByIw5AT_45pic8FnBNDmIGfB9s1hcEMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/stocna-hrana/index.vue?macro=true";
import { default as indexRgmTohmBwFnlKXy6PPQ0C4l3Zuzixs8pg1OXMZOSuDoMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/tezge/[page]/index.vue?macro=true";
import { default as zaboravljena_45sifraqI3ZqjP0ZcwQIaFiKvQ0MTWhvsGmVJcuqzrViQpa5z0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/zaboravljena-sifra.vue?macro=true";
import { default as index8ugrN3heupMBtyUIxJrl9IBiWB_5J1q88f7GyV49j5cMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-istorija/index.vue?macro=true";
import { default as index791M7HCT7Rj3iWAKVq0wb00_Mie_Zgf3ywnZaN30hP0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/vesti/[title]/index.vue?macro=true";
import { default as indexMq_LqEn4OFL4wkfJ6vMqyff6rpjBhaVG54OeTd1y0qgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/video/[title]/index.vue?macro=true";
import { default as index8RK5QDM_454T6XmmeDEp4WlYIuw8O_2RoM1vqHL1_6tpcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/anketa/[title]/index.vue?macro=true";
import { default as indexv3qraY40nbaLItxekNzwXrRt_45mXNCuPuTBmQ9Y3Bi8AMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijaci/index.vue?macro=true";
import { default as politika_45privatnostinRy_45yXLouRBNVjyNXHkAwZRQchSEq_45OJe0_LoLc2FXYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/politika-privatnosti.vue?macro=true";
import { default as indexQKYPgwd09sNGqk0lp8H_45WFkHklnp9ZpJy0CYOG1wBvUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/saveti/[title]/index.vue?macro=true";
import { default as djeram_45pijaca_45beogradyTYEkENbTv6BSuocU_45SR3rIj6DQs39i3UBeUxMv04OwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/djeram-pijaca-beograd.vue?macro=true";
import { default as indexHRlzJai70eWRbKoBZXQFtrti0qoua0X_45jy2YiW8ICYkMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/imena-zivotinja/index.vue?macro=true";
import { default as _91category_93EdCaEAx5uWaRcBoF9V_45TVHwBiORMADhcPhjdbnAfjocMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kategorija/[category].vue?macro=true";
import { default as indexr6BbYoAD_45fECZ4MDpA2IIvLr0HwXU9Wj3FDVncsr77cMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/bolesti/[animal]/index.vue?macro=true";
import { default as indexK15Vu_kC1Q4slIjMh9WYSegjg26TMIzjhZdk82FkBFAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-na-pijacama/index.vue?macro=true";
import { default as indexYuHInRCvorgeM_35Fkd2vcqKYWcFFGhgIw0w1QoPO5kMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama/index.vue?macro=true";
import { default as indexbEQ9xMMqtG3DvpmPeGajDocO6kIQGfMAZLcqytgGgJAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/index.vue?macro=true";
import { default as cvetkova_45pijaca_45beogradciUNsnJfNxa9Fzb1t0QUFbs44k_M3FiIuR_tFMlvEUgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cvetkova-pijaca-beograd.vue?macro=true";
import { default as indexCq_NLF84R89g4J3gUukv8wsoi00q0FrXaLBCBABWr40Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/preporuke/[title]/index.vue?macro=true";
import { default as index5DECd1pm_UbyuJ4S8LXwooCK8oZVQvD37uYFBiAH4uMMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/zastita/[protect]/index.vue?macro=true";
import { default as _91title_93VJzlHupZ5KPbOC0Kuct9_45VXwzvIGtMnkCP4Eb_45BH68UMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/anketa/rezultati/[title].vue?macro=true";
import { default as crkveni_45kalendar_45pretragapNYpbXQ5fwJ0wchG6IuiJ9nOBpKfiUd15ob3mSM7HOIMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar-pretraga.vue?macro=true";
import { default as palilulska_45pijaca_45beogradnZUmN6C_jc1NhraKIxOVPutz81ixvgiTN1JF_0zFym0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/palilulska-pijaca-beograd.vue?macro=true";
import { default as _91page_93qNtygCBWzFi6O6c0CGp4mkms4RdpKuXZ_45U__45uqlhYp4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/recepti/[category]/[page].vue?macro=true";
import { default as indexNn7qKOwEuNf7yngocsxWTC7D72Qm_45NWBjpLCSzjD5OgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/stocna-hrana/[food]/index.vue?macro=true";
import { default as _91page_93UQvD73IDyd62NxRqUHsswSxHN8sbkQsQ5kU_45aMvH5LgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/tezga/[lawyername]/[page].vue?macro=true";
import { default as kako_45kreirati_45tezga_45profilv3iZfbrPGucmivpbx6Schr650X64KgLjPgRhvz3P0C8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kako-kreirati-tezga-profil.vue?macro=true";
import { default as indexPPB6zaGUWH9RqJDtoBLVJJYBMTAOw8IWgc4o6LAs4N0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/[category]/index.vue?macro=true";
import { default as kalendar_45dogadjaja_45pretragamkKS6T6eOUUWGUPYG6f4SY_YOj_V5uu72y03eEMZyDsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja-pretraga.vue?macro=true";
import { default as uputstvo_45za_45brisanje_45nalogaVPVot4tnQlQ0A6W8UWEVO1AGiVJLRb5X8eAFTJK708UMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/uputstvo-za-brisanje-naloga.vue?macro=true";
import { default as index0OGPsKLVIhU4ig04DlmCQaPOxDDYHpPsHCRsYN0ujTQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/auth/[github]/callback/index.vue?macro=true";
import { default as _91page_93jy7EJqD8R4uaer_45bQbknclddUQoFGb9bxgfOro6csu4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kako-pomaze/kategorije/[page].vue?macro=true";
import { default as _91email_93fRxWIw_ueTFb_XfJhK4BhjdrLooH_b984X9_45TCNppi0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/promena-sifre/[token]/[email].vue?macro=true";
import { default as _91name_93Eaeom_45NrtH4fXJKkLmDL9R85xWC915bZb9lbc1Gj8U8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/svetac/[name].vue?macro=true";
import { default as indexFmAZVIz5Sko8YZAKYERbOxZAH_45Rv0DBGLHB8QBb8DeAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/imena-zivotinja/[animal]/index.vue?macro=true";
import { default as indexFm07xPdP8qWUAdl_45Z_45zdZRY6j5kiExYL_45mE4KvcI89oMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-okota-zivotinja/index.vue?macro=true";
import { default as _91id_93_45fmDHaui_oLbea65_45bNsiYOw7koTLFYJfW_fvhKAiz0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/recept/[category]/[title]/[id].vue?macro=true";
import { default as indexg4bJFSvz1AS_CcwWlRPJsAobU33lW88KD6k0_45Y2H8lIMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/[category]/index.vue?macro=true";
import { default as trznice_45pijace7LHDS_455nE1mb_452CBbdRhznN31KmY03fCdxYERY1K1LkMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/trznice-pijace.vue?macro=true";
import { default as index0nuIIN6ibND_jM90nCKg5kt1kE12LFEbP7kM_wpncFcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/zastita-od-bolesti/[type]/index.vue?macro=true";
import { default as indexKAvdmQmLu5cnrx6FBtRA61wORGqbF9iyFusneCE0c6wMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/[category]/index.vue?macro=true";
import { default as _91churchday_93GITb9rMbfRMq60Mp0u5xKtvnQcKYadhjcfwT2igDiHoMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/dan/[churchday].vue?macro=true";
import { default as _91name_93KPo7JWXy_DKkjbbDVCWXqODl7XMf0bbpa93ArS8JLpYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/adresar/[category]/[place]/[name].vue?macro=true";
import { default as indexA0j_4536zBqiOJMHDiZT0HoKL_R8Tb5MtRxX_45J556kw9IMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-na-pijacama/[products]/index.vue?macro=true";
import { default as indexQZaQNF_45lVIXiZAks5riwI2frhreJqHxR8m_45fGItTcwsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama/[category]/index.vue?macro=true";
import { default as indexET9_45sD_45adAkerH9SA8DzVWJiQeaqkEko14Ca9ikWEK0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/[category]/index.vue?macro=true";
import { default as _91month_93hz2t2CxxTjAO92SOtUNt9XDXsHQfQ1zmztQOts69ldEMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/za-mesec/[month].vue?macro=true";
import { default as _91year_93y9O5fQRTZTsCZBWQVFZ7Fyl8jnvZP3Qxeuz6cop1fSwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/zadusnice/[year].vue?macro=true";
import { default as indexPpMFzS7jQxdD_45aakMcSW24n7B6sgki9rm05dSTZxZN4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/bolesti-insekti-korovi/[type]/index.vue?macro=true";
import { default as _91year_93_dkzDlHD_HmN0SwbFLjSPIYWf5PJ8CX1ArufIfq_45UgcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91subcategory_93CJUvYWlneRy_45qARBF8Gdn_m_pp8nKzOr5oXAyaKJOiEMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/[category]/[subcategory].vue?macro=true";
import { default as indexnvJ_FCU4T6eGi2lD8LUf07Vw_45_45AC_oX_45R_ynDIpBP5UMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/index.vue?macro=true";
import { default as trznice_45veletrzniceu0Zr3ryM8mZ0c_45tzBsOgUKwZAAVIJMMJUhuJqjBP5qAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/trznice-veletrznice.vue?macro=true";
import { default as _91id_93pLKCJb5Mk0ggRPj4HGut0DoMjMRYRz_45QZYUoig8jgtAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kako-pomaze/[category]/[title]/[id].vue?macro=true";
import { default as _91page_93SaZ8ROpKp3l_HSJgmO7yXGG2n470ihz09ZzanyUfqOEMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/vesti/poljoprivredne-novosti/[page].vue?macro=true";
import { default as indexnWEwGpp1daJMsIWsfO3JV_hIyOmRH_BSj3J7oKweKCcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-na-pijaci/[singleproducts]/index.vue?macro=true";
import { default as indexs66oGy3L_0jHgcjtjoRNCU6Kk31PbKnz0MUmfwHkYBgMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-istorija/[categoryhistory]/index.vue?macro=true";
import { default as index3E6djRrAPEEW6lXgOnAzMFs4LAnpUqJBsF1fRiT55gsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglas/svi-oglasi/[customer]/[id]/index.vue?macro=true";
import { default as _91page_93hfPNLzm4_45FfIXNe1I_45MMavNrvJ2wYMB6aQbjwsjQxyAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/tezga/[lawyername]/[adcategory]/[page].vue?macro=true";
import { default as indexbu0PEBHlSXQAW78SGLiGPHIU1WzBN5axbfUeHXpCFVMMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/index.vue?macro=true";
import { default as _91year_93_45vZm5rAGGAQaEgGsMDu_HdAog_TG1FbnfgKPEquqxdoMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91subcategory_93OiDI_45vKOHdFSY2fAYMyukPw15u_45FUkWK_vgAsTEPST4Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/[category]/[subcategory].vue?macro=true";
import { default as _91year_93g7N8qOOJqCS7euBNTrGwSrkF5ZSAUlwGESqj_45cv034kMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91subcategory_93sXVC6BHMum2Q_c6hmYo8iVEXLW6AXtJDqfhfZpCcfEcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/[category]/[subcategory].vue?macro=true";
import { default as _91page_93_b_45_45shKxAHHJsffc7tDYV3w1GdY3Ln3wGz0XFEjNPnAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kako-pomaze/kategorije/[category]/[page].vue?macro=true";
import { default as _91name_93WrvPLtJO_5tNJ4yH1N2G5P0f78FzM_JtC2x7hbMtI4QMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/proizvod/[category]/[subcategory]/[name].vue?macro=true";
import { default as stoka_45za_45klanje_45evropska_45unijaM8QgQ6_4BvG1B6Hm5aml_akbSGwKUipRIGYI3v_45sgAIMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/stoka-za-klanje-evropska-unija.vue?macro=true";
import { default as _91year_93_45EVwLv6tQKRXKAbMJu430XdByKXChQ3kM77GLuL8YM0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91subcategory_93h5WDq0PmnO05rb8TNkMHzgnvxpiLByduFE1IbeRd8m8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/[category]/[subcategory].vue?macro=true";
import { default as indexyNNvBWQTNhQ_45Mbt3_45XzhQQdmGeR_45bSwLQtO9CHxV_45b0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-okota-zivotinja/[calendar]/index.vue?macro=true";
import { default as _91week_93EUx11Z5FyYMGJ4SekG2a_45Nwx9WVQlCfwIw0lbR3vEQ0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-stoke/[category]/[subcategory]/[week].vue?macro=true";
import { default as _91year_93SSA_aXLqG2K2_wDBWAS2AOOdzADJEphFkJj64PKDLZ0Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijaci/[subcategory]/[week]/[year].vue?macro=true";
import { default as indexz1Gqi4mbInJQWSBto0WScyOY49S0mcOdRNIi5TyQi4gMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/index.vue?macro=true";
import { default as indexxS3wCwo8cueYC0uiLJ9NyU_45ykJyG6y_45bUTzhNl1VKsAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglas/svi-oglasi/[customer]/[id]/[page]/index.vue?macro=true";
import { default as _91week_93kV9RvXLVTmZhaaC9VbRMvxpcrX6HI_kYHzNUBULWKUQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-pesticida/[category]/[subcategory]/[week].vue?macro=true";
import { default as insekticidi_45herbicidi_45fungicidigVFNj_45KBA_zy7Vs1km89u0XG2huJQP_45WTjhf236MNWwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/insekticidi-herbicidi-fungicidi.vue?macro=true";
import { default as indexiQFXzy3Ro_45CXX3DwGlkN_Rkoud5d4z9ZqTH4pPpz864Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/[category]/index.vue?macro=true";
import { default as _91week_93U506iuWaHxvsDY63MxAEQemgl9CsBJ2JfrXLvMp0LVUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijena-hrvatska/[category]/[subcategory]/[week].vue?macro=true";
import { default as _91year_938MrA_VYWyrcCnPoxT4OLJ1kSezNbBSOOAMbomozr8ZwMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/meseceve-mene-za-godinu/[year].vue?macro=true";
import { default as _91year_93qBhUHNleL7uf6_45_ChR9A1L9k8Y1tpCMa6_45VsARohaIcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91week_93teJRPDVT3KukSs2oaXU50MZO92m2CrjgbgiQYJedRmsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijena-crna-gora/[category]/[subcategory]/[week].vue?macro=true";
import { default as _91year_93Ipf2oDX54mX51xAuof4Uisctrak0OqBAYaj3_455rHplcMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/kalendar-posta/za-godinu/[year].vue?macro=true";
import { default as index_HQ9EIrFSdxYfTr_454rZDSLbTryv8X8IaYSBkC6_45_MVUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/[category]/index.vue?macro=true";
import { default as cene_45na_45pijacama_45srbija_45bosna_45i_45hercegovina_45hrvatskafbM4nJJMvtN2x6pyFG8QDJPaqr6NWN8ncyqUCG13c0gMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama-srbija-bosna-i-hercegovina-hrvatska.vue?macro=true";
import { default as _91year_93owvAXC56tkwlXlwG4VObDsoXyqqYsgLFgxH07pgTqyUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91subcategory_9391WZ7brZTN3AZZO1mNQVgZs01I3Te3wB71cwqB1o_45BQMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/[category]/[subcategory].vue?macro=true";
import { default as _91page_93jbqBJIs0t6dkZQka55nNGBJUkvQIyzwGt_45WLKcdxIbkMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/tezga/[lawyername]/[adcategory]/[adsubcategory]/[page].vue?macro=true";
import { default as indexjVexgXeZmpArNFFtAAu_PfjUEsA3oanDTds7OZNnJDEMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/[category]/index.vue?macro=true";
import { default as indexUAQFCOYq3VCDuiwzeZW4eaMrEmsHxY5e5BZd9bVXQtMMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-opreme-i-masina-za-bastu-i-dvoriste/[category]/index.vue?macro=true";
import { default as _91cityhistory_93lVNf9nvMaGGE0_wzSOxanR0epaD640Exbn9eN5xWjccMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-istorija/[categoryhistory]/[subhistory]/[cityhistory].vue?macro=true";
import { default as _91year_93VpoXBuudOf3pwvcqWI1JX_45jy5IdivOgFtTPJn0Nw8TYMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91subcategory_93_45FMpy1sh69oK4QG2hNmHPUwvnr2YRbrK1xsWCaXePZ8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/[category]/[subcategory].vue?macro=true";
import { default as _91year_930vBFfNowpcaK6Q3GueE_Jfayx6yblym3Rfj9J9sbwwsMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/[category]/[subcategory]/[year].vue?macro=true";
import { default as _91subcategory_93jJ2kqg0nBrZNHmcSssqQu_LP5WaJQAf_m4SKEDAdty8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/[category]/[subcategory].vue?macro=true";
import { default as _91week_93S_reQSd17tI1R6Byk4mSOpS7efMzxjakl96Cc2WcqjAMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-mineralnog-djubriva-i-semena/[category]/[subcategory]/[week].vue?macro=true";
import { default as _91week_932j3Of695uj0MmjeBX2BesctMhaHx9LgR_dFOwKolasEMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cena-zitarica-na-produktnoj-berzi/[category]/[subcategory]/[week].vue?macro=true";
import { default as _91week_93szNz_453iQkzOCV7SpJWIc_sfmIn82iEFZe3gt_x725r8Meta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/cijena-na-pijacama-bosna-i-hercegovina/[category]/[subcategory]/[week].vue?macro=true";
import { default as _91page_933lsDFYB27mAS077Nx1UbctUW_45alysCb83g_45bdYbiHBUMeta } from "/home/vladimir/Desktop/Projekti/marketNew/pages/oglas-ocene/[customername]/[customerid]/[customertype]/[customerrate]/[page].vue?macro=true";
export default [
  {
    name: "menu",
    path: "/menu",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/login.vue")
  },
  {
    name: "oglasi",
    path: "/oglasi",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi.vue"),
    children: [
  {
    name: "oglasi-category-page",
    path: ":category()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/[category]/[page].vue")
  },
  {
    name: "oglasi-svi-oglasi-page",
    path: "svi-oglasi/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/svi-oglasi/[page].vue")
  },
  {
    name: "oglasi-mesto-place-page",
    path: "mesto/:place()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/mesto/[place]/[page].vue")
  },
  {
    name: "oglasi-category-subcategory-page",
    path: ":category()/:subcategory()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/[category]/[subcategory]/[page].vue")
  },
  {
    name: "oglasi-mesto-place-category-page",
    path: "mesto/:place()/:category()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/mesto/[place]/[category]/[page].vue")
  },
  {
    name: "oglasi-mesto-place-category-subcategory-page",
    path: "mesto/:place()/:category()/:subcategory()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi/mesto/[place]/[category]/[subcategory]/[page].vue")
  }
]
  },
  {
    name: "kontakt",
    path: "/kontakt",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kontakt.vue")
  },
  {
    name: "adresari",
    path: "/adresari",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/adresari.vue"),
    children: [
  {
    name: "adresari-kategorije-page",
    path: "kategorije/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/kategorije/[page].vue")
  },
  {
    name: "adresari-mesto-place-page",
    path: "mesto/:place()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/mesto/[place]/[page].vue")
  },
  {
    name: "adresari-kategorija-category-page",
    path: "kategorija/:category()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/kategorija/[category]/[page].vue")
  },
  {
    name: "adresari-kategorija-category-place-page",
    path: "kategorija/:category()/:place()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/adresari/kategorija/[category]/[place]/[page].vue")
  }
]
  },
  {
    name: "cenovnik",
    path: "/cenovnik",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cenovnik.vue")
  },
  {
    name: "pretraga",
    path: "/pretraga",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/pretraga.vue")
  },
  {
    name: "marketing",
    path: "/marketing",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/marketing.vue")
  },
  {
    name: "proizvodi",
    path: "/proizvodi",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/proizvodi.vue"),
    children: [
  {
    name: "proizvodi-category-subcategory-sort-page",
    path: ":category()/:subcategory()/:sort()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/proizvodi/[category]/[subcategory]/[sort]/[page].vue")
  },
  {
    name: "proizvodi-category-subcategory-sort-filter-page",
    path: ":category()/:subcategory()/:sort()/:filter()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/proizvodi/[category]/[subcategory]/[sort]/[filter]/[page].vue")
  }
]
  },
  {
    name: "login-video",
    path: "/login-video",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/login-video.vue")
  },
  {
    name: "vesti",
    path: "/vesti",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/vesti/index.vue")
  },
  {
    name: "video",
    path: "/video",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/video/index.vue")
  },
  {
    name: "anketa",
    path: "/anketa",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/anketa/index.vue")
  },
  {
    name: "registracija",
    path: "/registracija",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/registracija.vue")
  },
  {
    name: "saveti",
    path: "/saveti",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/saveti/index.vue")
  },
  {
    name: "bolesti",
    path: "/bolesti",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/bolesti/index.vue")
  },
  {
    name: "zastita",
    path: "/zastita",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/zastita/index.vue")
  },
  {
    name: "recepti-page",
    path: "/recepti/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/recepti/[page].vue")
  },
  {
    name: "oglasi-pretraga",
    path: "/oglasi-pretraga",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglasi-pretraga.vue")
  },
  {
    name: "preporuke",
    path: "/preporuke",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/preporuke/index.vue")
  },
  {
    name: "recepti-pretraga",
    path: "/recepti-pretraga",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/recepti-pretraga.vue")
  },
  {
    name: korisnicki_45profilfZYr0u4ueBfzuNc_45ezDzFkzvJkpvfp1MLsoCN958aZYMeta?.name,
    path: "/korisnicki-profil",
    meta: { ...(korisnicki_45profilfZYr0u4ueBfzuNc_45ezDzFkzvJkpvfp1MLsoCN958aZYMeta || {}), ...{"middleware":["auth-customer"]} },
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil.vue"),
    children: [
  {
    name: "korisnicki-profil",
    path: "",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/index.vue")
  },
  {
    name: "korisnicki-profil-pratim",
    path: "pratim",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pratim.vue")
  },
  {
    name: "korisnicki-profil-profil",
    path: "profil",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/profil.vue")
  },
  {
    name: "korisnicki-profil-pracenje",
    path: "pracenje",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pracenje.vue")
  },
  {
    name: "korisnicki-profil-pratioci",
    path: "pratioci",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pratioci.vue")
  },
  {
    name: "korisnicki-profil-meni",
    path: "meni",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/meni/index.vue")
  },
  {
    name: "korisnicki-profil-novi-oglas",
    path: "novi-oglas",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/novi-oglas.vue")
  },
  {
    name: "korisnicki-profil-ocene",
    path: "ocene",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/ocene/index.vue")
  },
  {
    name: "korisnicki-profil-aktivni-oglasi",
    path: "aktivni-oglasi",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/aktivni-oglasi.vue")
  },
  {
    name: "korisnicki-profil-neaktivni-oglasi",
    path: "neaktivni-oglasi",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/neaktivni-oglasi.vue")
  },
  {
    name: "korisnicki-profil-obavestenja",
    path: "obavestenja",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/obavestenja/index.vue")
  },
  {
    name: "korisnicki-profil-tezga-registracija",
    path: "tezga-registracija",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/tezga-registracija.vue")
  },
  {
    name: "korisnicki-profil-pristupni-parametri",
    path: "pristupni-parametri",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/pristupni-parametri.vue")
  },
  {
    name: "korisnicki-profil-uspesno-dodat-oglas",
    path: "uspesno-dodat-oglas",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/uspesno-dodat-oglas.vue")
  },
  {
    name: "korisnicki-profil-statistika-mesec",
    path: "statistika/mesec",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/statistika/mesec/index.vue")
  },
  {
    name: "korisnicki-profil-oglas-title-id",
    path: "oglas/:title()/:id()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/oglas/[title]/[id]/index.vue")
  },
  {
    name: "korisnicki-profil-statistika-nedelja",
    path: "statistika/nedelja",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/statistika/nedelja/index.vue")
  },
  {
    name: "korisnicki-profil-poruke-prikaz-oglasa",
    path: "poruke/prikaz-oglasa",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/poruke/prikaz-oglasa/index.vue")
  },
  {
    name: "korisnicki-profil-poruke-slanje-poruke-adid",
    path: "poruke/slanje-poruke/:adid()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/poruke/slanje-poruke/[adid].vue")
  },
  {
    name: "korisnicki-profil-promena-podataka-id",
    path: "promena-podataka/:id()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/promena-podataka/[id]/index.vue")
  },
  {
    name: "korisnicki-profil-poruke-slanje-poruke-oglas-conversationid",
    path: "poruke/slanje-poruke-oglas/:conversationid()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/poruke/slanje-poruke-oglas/[conversationid].vue")
  },
  {
    name: "korisnicki-profil-ocene-customerid-customertype-customerrate-page",
    path: "ocene/:customerid()/:customertype()/:customerrate()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/korisnicki-profil/ocene/[customerid]/[customertype]/[customerrate]/[page].vue")
  }
]
  },
  {
    name: "uslovi-koriscenja",
    path: "/uslovi-koriscenja",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/uslovi-koriscenja.vue")
  },
  {
    name: "cena-weeks",
    path: "/cena/:weeks()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena/[weeks]/index.vue")
  },
  {
    name: kalendar_45dogadjajard1QCwngCjNWuHMyLJYvKqjxJHRLKkg1WAvjOU2JstQMeta?.name,
    path: "/kalendar-dogadjaja",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja.vue"),
    children: [
  {
    name: "kalendar-dogadjaja",
    path: "",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/index.vue")
  },
  {
    name: "kalendar-dogadjaja-event",
    path: ":event()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/index.vue")
  },
  {
    name: "kalendar-dogadjaja-dogadjaji-page",
    path: "dogadjaji/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/dogadjaji/[page].vue")
  },
  {
    name: "kalendar-dogadjaja-event-title",
    path: ":event()/:title()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/[title]/index.vue")
  },
  {
    name: "kalendar-dogadjaja-dogadjaji-year-page",
    path: "dogadjaji/:year()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/dogadjaji/[year]/[page].vue")
  },
  {
    name: "kalendar-dogadjaja-dogadjaji-year-month-page",
    path: "dogadjaji/:year()/:month()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/dogadjaji/[year]/[month]/[page].vue")
  },
  {
    name: "kalendar-dogadjaja-event-kategorija-year-page",
    path: ":event()/kategorija/:year()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/kategorija/[year]/[page].vue")
  },
  {
    name: "kalendar-dogadjaja-event-kategorija-year-month-page",
    path: ":event()/kategorija/:year()/:month()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja/[event]/kategorija/[year]/[month]/[page].vue")
  }
]
  },
  {
    name: "oglas-title-id",
    path: "/oglas/:title()/:id()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglas/[title]/[id].vue")
  },
  {
    name: "stocna-hrana",
    path: "/stocna-hrana",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/stocna-hrana/index.vue")
  },
  {
    name: "tezge-page",
    path: "/tezge/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/tezge/[page]/index.vue")
  },
  {
    name: "zaboravljena-sifra",
    path: "/zaboravljena-sifra",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/zaboravljena-sifra.vue")
  },
  {
    name: "cene-istorija",
    path: "/cene-istorija",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-istorija/index.vue")
  },
  {
    name: "vesti-title",
    path: "/vesti/:title()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/vesti/[title]/index.vue")
  },
  {
    name: "video-title",
    path: "/video/:title()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/video/[title]/index.vue")
  },
  {
    name: "anketa-title",
    path: "/anketa/:title()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/anketa/[title]/index.vue")
  },
  {
    name: "cene-na-pijaci",
    path: "/cene-na-pijaci",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijaci/index.vue")
  },
  {
    name: "politika-privatnosti",
    path: "/politika-privatnosti",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/politika-privatnosti.vue")
  },
  {
    name: "saveti-title",
    path: "/saveti/:title()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/saveti/[title]/index.vue")
  },
  {
    name: "djeram-pijaca-beograd",
    path: "/djeram-pijaca-beograd",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/djeram-pijaca-beograd.vue")
  },
  {
    name: "imena-zivotinja",
    path: "/imena-zivotinja",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/imena-zivotinja/index.vue")
  },
  {
    name: "kategorija-category",
    path: "/kategorija/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kategorija/[category].vue")
  },
  {
    name: "bolesti-animal",
    path: "/bolesti/:animal()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/bolesti/[animal]/index.vue")
  },
  {
    name: "cena-na-pijacama",
    path: "/cena-na-pijacama",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-na-pijacama/index.vue")
  },
  {
    name: "cene-na-pijacama",
    path: "/cene-na-pijacama",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama/index.vue")
  },
  {
    name: "crkveni-kalendar",
    path: "/crkveni-kalendar",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/index.vue")
  },
  {
    name: "cvetkova-pijaca-beograd",
    path: "/cvetkova-pijaca-beograd",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cvetkova-pijaca-beograd.vue")
  },
  {
    name: "preporuke-title",
    path: "/preporuke/:title()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/preporuke/[title]/index.vue")
  },
  {
    name: "zastita-protect",
    path: "/zastita/:protect()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/zastita/[protect]/index.vue")
  },
  {
    name: "anketa-rezultati-title",
    path: "/anketa/rezultati/:title()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/anketa/rezultati/[title].vue")
  },
  {
    name: "crkveni-kalendar-pretraga",
    path: "/crkveni-kalendar-pretraga",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar-pretraga.vue")
  },
  {
    name: "palilulska-pijaca-beograd",
    path: "/palilulska-pijaca-beograd",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/palilulska-pijaca-beograd.vue")
  },
  {
    name: "recepti-category-page",
    path: "/recepti/:category()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/recepti/[category]/[page].vue")
  },
  {
    name: "stocna-hrana-food",
    path: "/stocna-hrana/:food()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/stocna-hrana/[food]/index.vue")
  },
  {
    name: "tezga-lawyername-page",
    path: "/tezga/:lawyername()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/tezga/[lawyername]/[page].vue")
  },
  {
    name: "kako-kreirati-tezga-profil",
    path: "/kako-kreirati-tezga-profil",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kako-kreirati-tezga-profil.vue")
  },
  {
    name: "cene-stoke-category",
    path: "/cene-stoke/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/[category]/index.vue")
  },
  {
    name: "kalendar-dogadjaja-pretraga",
    path: "/kalendar-dogadjaja-pretraga",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-dogadjaja-pretraga.vue")
  },
  {
    name: "uputstvo-za-brisanje-naloga",
    path: "/uputstvo-za-brisanje-naloga",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/uputstvo-za-brisanje-naloga.vue")
  },
  {
    name: "auth-github-callback",
    path: "/auth/:github()/callback",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/auth/[github]/callback/index.vue")
  },
  {
    name: "kako-pomaze-kategorije-page",
    path: "/kako-pomaze/kategorije/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kako-pomaze/kategorije/[page].vue")
  },
  {
    name: "promena-sifre-token-email",
    path: "/promena-sifre/:token()/:email()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/promena-sifre/[token]/[email].vue")
  },
  {
    name: "crkveni-kalendar-svetac-name",
    path: "/crkveni-kalendar/svetac/:name()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/svetac/[name].vue")
  },
  {
    name: "imena-zivotinja-animal",
    path: "/imena-zivotinja/:animal()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/imena-zivotinja/[animal]/index.vue")
  },
  {
    name: "kalendar-okota-zivotinja",
    path: "/kalendar-okota-zivotinja",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-okota-zivotinja/index.vue")
  },
  {
    name: "recept-category-title-id",
    path: "/recept/:category()/:title()/:id()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/recept/[category]/[title]/[id].vue")
  },
  {
    name: "cene-pesticida-category",
    path: "/cene-pesticida/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/[category]/index.vue")
  },
  {
    name: "cijene-crna-gora-trznice-pijace",
    path: "/cijene-crna-gora/trznice-pijace",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/trznice-pijace.vue")
  },
  {
    name: "zastita-od-bolesti-type",
    path: "/zastita-od-bolesti/:type()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/zastita-od-bolesti/[type]/index.vue")
  },
  {
    name: "cijene-hrvatska-category",
    path: "/cijene-hrvatska/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/[category]/index.vue")
  },
  {
    name: "crkveni-kalendar-dan-churchday",
    path: "/crkveni-kalendar/dan/:churchday()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/dan/[churchday].vue")
  },
  {
    name: "adresar-category-place-name",
    path: "/adresar/:category()/:place()/:name()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/adresar/[category]/[place]/[name].vue")
  },
  {
    name: "cena-na-pijacama-products",
    path: "/cena-na-pijacama/:products()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-na-pijacama/[products]/index.vue")
  },
  {
    name: "cene-na-pijacama-category",
    path: "/cene-na-pijacama/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama/[category]/index.vue")
  },
  {
    name: "cijene-crna-gora-category",
    path: "/cijene-crna-gora/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/[category]/index.vue")
  },
  {
    name: "crkveni-kalendar-za-mesec-month",
    path: "/crkveni-kalendar/za-mesec/:month()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/za-mesec/[month].vue")
  },
  {
    name: "crkveni-kalendar-zadusnice-year",
    path: "/crkveni-kalendar/zadusnice/:year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/zadusnice/[year].vue")
  },
  {
    name: "bolesti-insekti-korovi-type",
    path: "/bolesti-insekti-korovi/:type()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/bolesti-insekti-korovi/[type]/index.vue")
  },
  {
    name: "cene-stoke-category-subcategory",
    path: "/cene-stoke/:category()/:subcategory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/[category]/[subcategory].vue"),
    children: [
  {
    name: "cene-stoke-category-subcategory-year",
    path: ":year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/[category]/[subcategory]/[year].vue")
  }
]
  },
  {
    name: "cene-zitarica-produktna-berza",
    path: "/cene-zitarica-produktna-berza",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/index.vue")
  },
  {
    name: "cijene-hrvatska-trznice-veletrznice",
    path: "/cijene-hrvatska/trznice-veletrznice",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/trznice-veletrznice.vue")
  },
  {
    name: "kako-pomaze-category-title-id",
    path: "/kako-pomaze/:category()/:title()/:id()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kako-pomaze/[category]/[title]/[id].vue")
  },
  {
    name: "vesti-poljoprivredne-novosti-page",
    path: "/vesti/poljoprivredne-novosti/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/vesti/poljoprivredne-novosti/[page].vue")
  },
  {
    name: "cena-na-pijaci-singleproducts",
    path: "/cena-na-pijaci/:singleproducts()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-na-pijaci/[singleproducts]/index.vue")
  },
  {
    name: "cene-istorija-categoryhistory",
    path: "/cene-istorija/:categoryhistory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-istorija/[categoryhistory]/index.vue")
  },
  {
    name: "oglas-svi-oglasi-customer-id",
    path: "/oglas/svi-oglasi/:customer()/:id()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglas/svi-oglasi/[customer]/[id]/index.vue")
  },
  {
    name: "tezga-lawyername-adcategory-page",
    path: "/tezga/:lawyername()/:adcategory()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/tezga/[lawyername]/[adcategory]/[page].vue")
  },
  {
    name: "cene-mineralnog-djubriva-i-semena",
    path: "/cene-mineralnog-djubriva-i-semena",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/index.vue")
  },
  {
    name: "cene-pesticida-category-subcategory",
    path: "/cene-pesticida/:category()/:subcategory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/[category]/[subcategory].vue"),
    children: [
  {
    name: "cene-pesticida-category-subcategory-year",
    path: ":year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/[category]/[subcategory]/[year].vue")
  }
]
  },
  {
    name: "cijene-hrvatska-category-subcategory",
    path: "/cijene-hrvatska/:category()/:subcategory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/[category]/[subcategory].vue"),
    children: [
  {
    name: "cijene-hrvatska-category-subcategory-year",
    path: ":year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-hrvatska/[category]/[subcategory]/[year].vue")
  }
]
  },
  {
    name: "kako-pomaze-kategorije-category-page",
    path: "/kako-pomaze/kategorije/:category()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kako-pomaze/kategorije/[category]/[page].vue")
  },
  {
    name: "proizvod-category-subcategory-name",
    path: "/proizvod/:category()/:subcategory()/:name()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/proizvod/[category]/[subcategory]/[name].vue")
  },
  {
    name: "cene-stoke-stoka-za-klanje-evropska-unija",
    path: "/cene-stoke/stoka-za-klanje-evropska-unija",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-stoke/stoka-za-klanje-evropska-unija.vue")
  },
  {
    name: "cijene-crna-gora-category-subcategory",
    path: "/cijene-crna-gora/:category()/:subcategory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/[category]/[subcategory].vue"),
    children: [
  {
    name: "cijene-crna-gora-category-subcategory-year",
    path: ":year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-crna-gora/[category]/[subcategory]/[year].vue")
  }
]
  },
  {
    name: "kalendar-okota-zivotinja-calendar",
    path: "/kalendar-okota-zivotinja/:calendar()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/kalendar-okota-zivotinja/[calendar]/index.vue")
  },
  {
    name: "cena-stoke-category-subcategory-week",
    path: "/cena-stoke/:category()/:subcategory()/:week()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-stoke/[category]/[subcategory]/[week].vue")
  },
  {
    name: "cene-na-pijaci-subcategory-week-year",
    path: "/cene-na-pijaci/:subcategory()/:week()/:year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijaci/[subcategory]/[week]/[year].vue")
  },
  {
    name: "cijene-na-pijacama-bosna-i-hercegovina",
    path: "/cijene-na-pijacama-bosna-i-hercegovina",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/index.vue")
  },
  {
    name: "oglas-svi-oglasi-customer-id-page",
    path: "/oglas/svi-oglasi/:customer()/:id()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglas/svi-oglasi/[customer]/[id]/[page]/index.vue")
  },
  {
    name: "cena-pesticida-category-subcategory-week",
    path: "/cena-pesticida/:category()/:subcategory()/:week()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-pesticida/[category]/[subcategory]/[week].vue")
  },
  {
    name: "cene-pesticida-insekticidi-herbicidi-fungicidi",
    path: "/cene-pesticida/insekticidi-herbicidi-fungicidi",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-pesticida/insekticidi-herbicidi-fungicidi.vue")
  },
  {
    name: "cene-zitarica-produktna-berza-category",
    path: "/cene-zitarica-produktna-berza/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/[category]/index.vue")
  },
  {
    name: "cijena-hrvatska-category-subcategory-week",
    path: "/cijena-hrvatska/:category()/:subcategory()/:week()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijena-hrvatska/[category]/[subcategory]/[week].vue")
  },
  {
    name: "crkveni-kalendar-meseceve-mene-za-godinu-year",
    path: "/crkveni-kalendar/meseceve-mene-za-godinu/:year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/meseceve-mene-za-godinu/[year].vue")
  },
  {
    name: "cene-na-pijacama-category-subcategory-year",
    path: "/cene-na-pijacama/:category()/:subcategory()/:year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama/[category]/[subcategory]/[year].vue")
  },
  {
    name: "cijena-crna-gora-category-subcategory-week",
    path: "/cijena-crna-gora/:category()/:subcategory()/:week()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijena-crna-gora/[category]/[subcategory]/[week].vue")
  },
  {
    name: "crkveni-kalendar-kalendar-posta-za-godinu-year",
    path: "/crkveni-kalendar/kalendar-posta/za-godinu/:year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/crkveni-kalendar/kalendar-posta/za-godinu/[year].vue")
  },
  {
    name: "cene-mineralnog-djubriva-i-semena-category",
    path: "/cene-mineralnog-djubriva-i-semena/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/[category]/index.vue")
  },
  {
    name: "cene-na-pijacama-srbija-bosna-i-hercegovina-hrvatska",
    path: "/cene-na-pijacama-srbija-bosna-i-hercegovina-hrvatska",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-na-pijacama-srbija-bosna-i-hercegovina-hrvatska.vue")
  },
  {
    name: "cene-zitarica-produktna-berza-category-subcategory",
    path: "/cene-zitarica-produktna-berza/:category()/:subcategory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/[category]/[subcategory].vue"),
    children: [
  {
    name: "cene-zitarica-produktna-berza-category-subcategory-year",
    path: ":year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-zitarica-produktna-berza/[category]/[subcategory]/[year].vue")
  }
]
  },
  {
    name: "tezga-lawyername-adcategory-adsubcategory-page",
    path: "/tezga/:lawyername()/:adcategory()/:adsubcategory()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/tezga/[lawyername]/[adcategory]/[adsubcategory]/[page].vue")
  },
  {
    name: "cijene-na-pijacama-bosna-i-hercegovina-category",
    path: "/cijene-na-pijacama-bosna-i-hercegovina/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/[category]/index.vue")
  },
  {
    name: "cena-opreme-i-masina-za-bastu-i-dvoriste-category",
    path: "/cena-opreme-i-masina-za-bastu-i-dvoriste/:category()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-opreme-i-masina-za-bastu-i-dvoriste/[category]/index.vue")
  },
  {
    name: "cene-istorija-categoryhistory-subhistory-cityhistory",
    path: "/cene-istorija/:categoryhistory()/:subhistory()/:cityhistory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-istorija/[categoryhistory]/[subhistory]/[cityhistory].vue")
  },
  {
    name: "cene-mineralnog-djubriva-i-semena-category-subcategory",
    path: "/cene-mineralnog-djubriva-i-semena/:category()/:subcategory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/[category]/[subcategory].vue"),
    children: [
  {
    name: "cene-mineralnog-djubriva-i-semena-category-subcategory-year",
    path: ":year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cene-mineralnog-djubriva-i-semena/[category]/[subcategory]/[year].vue")
  }
]
  },
  {
    name: "cijene-na-pijacama-bosna-i-hercegovina-category-subcategory",
    path: "/cijene-na-pijacama-bosna-i-hercegovina/:category()/:subcategory()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/[category]/[subcategory].vue"),
    children: [
  {
    name: "cijene-na-pijacama-bosna-i-hercegovina-category-subcategory-year",
    path: ":year()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijene-na-pijacama-bosna-i-hercegovina/[category]/[subcategory]/[year].vue")
  }
]
  },
  {
    name: "cena-mineralnog-djubriva-i-semena-category-subcategory-week",
    path: "/cena-mineralnog-djubriva-i-semena/:category()/:subcategory()/:week()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-mineralnog-djubriva-i-semena/[category]/[subcategory]/[week].vue")
  },
  {
    name: "cena-zitarica-na-produktnoj-berzi-category-subcategory-week",
    path: "/cena-zitarica-na-produktnoj-berzi/:category()/:subcategory()/:week()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cena-zitarica-na-produktnoj-berzi/[category]/[subcategory]/[week].vue")
  },
  {
    name: "cijena-na-pijacama-bosna-i-hercegovina-category-subcategory-week",
    path: "/cijena-na-pijacama-bosna-i-hercegovina/:category()/:subcategory()/:week()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/cijena-na-pijacama-bosna-i-hercegovina/[category]/[subcategory]/[week].vue")
  },
  {
    name: "oglas-ocene-customername-customerid-customertype-customerrate-page",
    path: "/oglas-ocene/:customername()/:customerid()/:customertype()/:customerrate()/:page()",
    component: () => import("/home/vladimir/Desktop/Projekti/marketNew/pages/oglas-ocene/[customername]/[customerid]/[customertype]/[customerrate]/[page].vue")
  }
]